<div class="custom-autocomplete-wrapper position-relative" [class.autocomplete-is-invalid]="isInvalid">
  <ng-autocomplete
    #autoComplete
    [data]="internalData"
    [searchKeyword]="searchKeyword"
    [initialValue]="selectedValue"
    [customFilter]="customFilter"
    [selectedValueRender]="selectedValueRender"
    [placeholder]="placeholder"
    [isLoading]="false"
    [disabled]="disabled"
    [debounceTime]="debounceTime"
    [minQueryLength]="minQueryLength"
    (selected)="onSelected($event)"
    (inputChanged)="onInputChanged($event)"
    (inputCleared)="onInputCleared()"
    (inputFocused)="onFocus()"
    [itemTemplate]="itemTemplate"
    [notFoundTemplate]="notFoundTemplate"
    appUppercase>
  </ng-autocomplete>

  <!-- Indicador de loading posicionado dentro del input -->
  <div class="autocomplete-loading-spinner" *ngIf="isLoading">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Cargando...</span>
    </div>
  </div>
</div>

<!-- Template para items del autocomplete -->
<ng-template #itemTemplate let-item>
  <div class="autocomplete-item p-2">
    <div [ngClass]="showSecondaryText ? 'fw-semibold' : 'text-normal'" [innerHTML]="item[searchKeyword]"></div>
    <div class="text-muted small" *ngIf="showSecondaryText && item[secondaryTextField]">
      <i [class]="iconClass + ' me-1'"></i>{{item[secondaryTextField]}}
    </div>
  </div>
</ng-template>

<!-- Template cuando no se encuentran resultados -->
<ng-template #notFoundTemplate>
  <div class="p-3 text-center text-muted">
    <i class="ri-search-line fs-4 d-block mb-2"></i>
    No se encontraron resultados
  </div>
</ng-template>

